/**
 * Word font name → CSS font-family stack, the local-font-first strategy:
 * try the genuine installed font (admin machines with Office have Calibri &
 * co.), fall back to a bundled metric-compatible substitute served under an
 * aliased family (fonts.css), then a generic family so line breaks stay
 * close to Word even for exotic names.
 */

/** Word font → the metric-compatible alias family declared in fonts.css. */
const METRIC_ALIASES = {
  Calibri: 'Studio Calibri',
  'Calibri Light': 'Studio Calibri',
  Cambria: 'Studio Cambria',
  'Times New Roman': 'Studio Times',
  Arial: 'Studio Arial',
  Helvetica: 'Studio Arial',
  'Courier New': 'Studio Courier',
  Courier: 'Studio Courier',
  Carlito: 'Studio Calibri',
  Caladea: 'Studio Cambria',
  'Liberation Serif': 'Studio Times',
  'Liberation Sans': 'Studio Arial',
  'Liberation Mono': 'Studio Courier',
  Tinos: 'Studio Times',
  Arimo: 'Studio Arial',
  Cousine: 'Studio Courier',
}

const SERIF_NAMES = new Set([
  'Times New Roman',
  'Cambria',
  'Caladea',
  'Georgia',
  'Garamond',
  'Book Antiqua',
  'Palatino Linotype',
  'Constantia',
  'Sylfaen',
  'Liberation Serif',
  'Tinos',
  'Cambria Math',
])

const MONO_NAMES = new Set(['Courier New', 'Courier', 'Consolas', 'Liberation Mono', 'Cousine'])

function genericFor(name) {
  if (MONO_NAMES.has(name)) return 'monospace'
  if (SERIF_NAMES.has(name)) return 'serif'
  return 'sans-serif'
}

const stackCache = new Map()

/**
 * Full CSS font-family value for a Word font name, quoted and fallback-
 * chained. Empty input → '' (caller omits the declaration and the document
 * default cascades).
 */
export function fontFamilyCss(name) {
  if (!name || typeof name !== 'string') return ''
  const cached = stackCache.get(name)
  if (cached !== undefined) return cached

  const clean = name.replace(/['"]/g, '').trim()
  if (!clean) return ''

  const parts = [`'${clean}'`]
  const alias = METRIC_ALIASES[clean]
  if (alias && alias !== clean) parts.push(`'${alias}'`)
  parts.push(genericFor(clean))

  const stack = parts.join(', ')
  stackCache.set(name, stack)
  return stack
}
